import { COLORS as COMPS_COLORS } from '@cuemath/comps';

const COLORS = {
  ABBEY: '#2B2B2B',
  AMBER: '#FFBF00',
  ASH: '#858DA6',
  ASH_1: '#B8C6D9',
  BITTERSWEET: '#FF6060',
  BITTERSWEET_LIGHT: '#FF606066',
  BLACK: '#000000',
  BORDER: '#EEEEEE',
  BOSTON_BLUE: '#4183c4',
  BRASS: '#aeae43',
  BRIGHT_GREEN: '#6DD400',
  CAPRI: '#00c0ff',
  CAROLINA_BLUE: '#5ca0d3',
  CERULEAN: '#01A5F2',
  CLOUD: '#F7F7FA',
  COLA: 'rgba(0, 0, 0, 0.8)',
  COLA_LIGHT: 'rgba(0, 0, 0, 0.5)',
  COLA_LIGHTER: 'rgba(0, 0, 0, 0.3)',
  DARK_GREEN: '#009e60',
  DARK_PINK: '#e75480',
  DISABLE_COLOR: '#bac0c3',
  ERROR: '#EC7063',
  GALLERY: '#eeeeee',
  GRAY: '#808080',
  GRAY_LIGHT: '#e2e4eb',
  GREEN: '#00FF00',
  HAWKESBLUE: '#DAE9FC',
  HEART_LIGHT: '#FF98C3',
  HEX_GREY: '#B3B3B3',
  HIGHLIGHT: '#EEEEEE',
  IRON: '#cacbcd',
  IRON_LIGHT: '#e0e1e2',
  LIGHTRED: 'rgb(229, 115, 115, 0.6)',
  LIGHT_PASTEL_PURPLE: '#b19cd9',
  LINK: '#0177FF',
  NEGATIVE: '#EA5959',
  POLICE_BLUE_LIGHT: 'rgba(51, 79, 110, 0.1)',
  POSITIVE: '#2AC3AA',
  PRIMARY: '#1657E4',
  PURPLE: '#660099',
  RAISIN_BLACK_LIGHT: 'rgba(34, 36, 38, 0.15)',
  READONLY: '#eeeeee',
  RED: 'rgb(229, 115, 115)',
  RUSTY_RED: '#dd3344',
  SCIENCEBLUE: '#0158D8',
  SECONDARY: '#0177FF',
  SELECTABLE: '#D4E6F1',
  SHINY_SHAMROCK: '#69ae82',
  SILVERCHALICE: '#9E9E9E',
  SKY: '#01A5F2',
  FONT: '#2B2B2BBF',
  SKY_DARK: '#0a80d5',
  SKY_XLIGHT: '#8DD5F1',
  SKY_XXLIGHT: '#ECF8FF',
  SUCCESS: '#73C6B6',
  TRANSPARENTRED: 'rgb(229, 115, 115, 0.3)',
  WHITE: '#FFFFFF',
  WILD_SAND: '#F6F6F6',
  NOBEL: '#9b9b9b',
  WARNING_BG: '#FFF3CD',
  WARNING_BORDER: '#FFC107',
  WARNING_TEXT: '#856404',
  YELLOW: '#FFFF00',
  LIGHT_GREEN: '#90EE90',

  YELLOW_1: '#FFF1CC',
  YELLOW_2: '#FFDB80',
  YELLOW_3: '#FFCC4D',
  YELLOW_4: '#FFB700',
  YELLOW_5: '#E58600',
  YELLOW_6: '#B25900',

  ORANGE_1: '#FFDDCC',
  ORANGE_2: '#FFC2A3',
  ORANGE_3: '#FFAA80',
  ORANGE_4: '#FF884D',
  ORANGE_5: '#EC5B13',
  ORANGE_6: '#B23C00',

  PURPLE_1: '#FFE0FD',
  PURPLE_2: '#FFC2FA',
  PURPLE_3: '#FFA3F7',
  PURPLE_4: '#FF80F4',
  PURPLE_5: '#D926CA',
  PURPLE_6: '#AA099C',

  GREEN_1: '#D0FBE5',
  GREEN_2: '#89F5BF',
  GREEN_3: '#40F098',
  GREEN_4: '#00E573',
  GREEN_5: '#00B259',
  GREEN_6: '#007038',

  BLUE_1: '#D6F5FF',
  BLUE_2: '#99E5FF',
  BLUE_3: '#66D9FF',
  BLUE_4: '#33CCFF',
  BLUE_5: '#0086E5',
  BLUE_6: '#0055CC',

  RED_1: '#FFDBDB',
  RED_2: '#FFB2B2',
  RED_3: '#FF8F8F',
  RED_4: '#FF5B4D',
  RED_5: '#F2330D',
  RED_6: '#B21E00',

  BLACK_1: '#0D0D0D',
  BLACK_2: '#141414',
  BLACK_3: '#191919',
  BLACK_4: '#252525',
  BLACK_5: '#313131',

  WHITE_1: '#FFFFFF',
  WHITE_2: '#FAFAFA',
  WHITE_3: '#F5F5F5',
  WHITE_4: '#EBEBEB',
  WHITE_5: '#DADADA',

  BLACK_T_02: 'rgba(0, 0, 0, 0.02)',
  BLACK_T_04: 'rgba(0, 0, 0, 0.04)',
  BLACK_T_08: 'rgba(0, 0, 0, 0.08)',
  BLACK_T_15: 'rgba(0, 0, 0, 0.15)',
  BLACK_T_20: 'rgba(0, 0, 0, 0.20)',
  BLACK_T_38: 'rgba(0, 0, 0, 0.38)',
  BLACK_T_60: 'rgba(0, 0, 0, 0.6)',
  BLACK_T_80: 'rgba(0, 0, 0, 0.80)',
  BLACK_T_87: 'rgba(0, 0, 0, 0.87)',

  WHITE_T_03: 'rgba(255, 255, 255, 0.03)',
  WHITE_T_05: 'rgba(255, 255, 255, 0.05)',
  WHITE_T_10: 'rgba(255, 255, 255, 0.1)',
  WHITE_T_15: 'rgba(255, 255, 255, 0.15)',
  WHITE_T_38: 'rgba(255, 255, 255, 0.38)',
  WHITE_T_60: 'rgba(255, 255, 255, 0.6)',
  WHITE_T_87: 'rgba(255, 255, 255, 0.87)',

  GREY_1: '#F6F6F6',
  GREY_2: '#E0E0E0',
  GREY_3: '#B3B3B3',
  GREY_4: '#808080',

  REAL_BLACK: '#000000',
  REAL_BLACK_60: 'rgba(0, 0, 0, 0.6)',
  REAL_BLACK_50: 'rgba(0, 0, 0, 0.5)',
  REAL_BLACK_30: 'rgba(0, 0, 0, 0.3)',
  REAL_BLACK_15: 'rgba(0, 0, 0, 0.15)',
  REAL_BLACK_10: 'rgba(0, 0, 0, 0.1)',

  BLACK_65: 'rgba(43, 43, 43, 0.65)',
  BLACK_75: 'rgba(43, 43, 43, 0.75)',
  BLACK_50: 'rgba(43, 43, 43, 0.5)',
  BLACK_10: 'rgba(43, 43, 43, 0.1)',

  WHITE_10: '#D9D9D9',
  WHITE_20: '#E6E6E6',
  WHITE_30: '#F2F2F2',
  WHITE_70: 'rgba(255, 255, 255, 0.7)',

  GREEN_20: 'rgba(0, 229, 115, 0.2)',

  PURPLE_20: 'rgba(255, 128, 244, 0.20)',

  // TODO: REMOVE this color
  FLOWER: '#DE5EE0',

  TRANSPARENT: 'transparent',

  // Support Agent Console - Gold/Cream theme
  GOLD_50: '#fdf8ef',
  GOLD_100: '#f9ecd3',
  GOLD_200: '#f0d9a8',
  GOLD_300: '#e4c177',
  GOLD_500: '#c89b3c',
  GOLD_600: '#a67f2e',
  GOLD_700: '#9a7520',
  GOLD_900: '#5c4512',
  CREAM_BG: '#faf8f5',
  CREAM_BG_2: '#f3efe9',
  CREAM_BG_3: '#ebe5dc',
  CREAM_BORDER: '#e8e2da',
  CREAM_BORDER_2: '#d6cfc6',
  CREAM_BORDER_3: '#c4bdb4',
};

const toRGB = hex => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  return result
    ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)]
    : null;
};

export const toRGBA = (hex, alpha) => {
  const rgb = toRGB(hex);

  return rgb ? `rgba(${rgb.join(', ')}, ${alpha})` : null;
};

export const getRandomColor = hashCode => {
  const { SUN_XLIGHT, ORANGE_XLIGHT, FLOWER_XLIGHT, GRASS_XLIGHT, SKY_XLIGHT } =
    COMPS_COLORS || {};

  const COLORS_LIST = [
    SUN_XLIGHT,
    ORANGE_XLIGHT,
    FLOWER_XLIGHT,
    GRASS_XLIGHT,
    SKY_XLIGHT,
  ];
  const colorIndex = hashCode % COLORS_LIST.length;
  const randomColor = COLORS_LIST[Math.abs(colorIndex)];

  return randomColor;
};

export default COLORS;
